












import { Component, Vue, Prop } from "vue-property-decorator";
import MonitoringViewer from './components/monitoring-viewer/MonitoringViewer.vue';
import * as analysesService from "@/services/analyses/index";
import * as cropsService from "@/services/crops";
import * as monitoringService from '@/services/monitoring';
import { monitoring } from '@/store/monitoring';
import { Analysis } from "@/api/analyses/types";
import AgroInterativeLoading from "@/components/agroInterativeLoading/AgroInterativeLoading.vue";

@Component({
  name: "Monitoring",
  components: {
      MonitoringViewer,
      AgroInterativeLoading,
  },
})
export default class Monitoring extends Vue {
  @Prop({ type: String, default: "" }) private uuid?: string;
  @Prop({ type: String, default: "" }) private source?: string;

  private polling: number | null = null;

  private mounted() {
    this.trackAnalysis(0);
  }

  private trackAnalysis(timeout: number = 1) {
    this.polling = setTimeout(async () => {
      try {
        await analysesService.getByUuid(this.uuid!);
        if (!this.analysis) {
          this.trackAnalysis(timeout === 0 ? 1 : Math.min(7000, timeout * 10));
        }
      } catch {}
    }, timeout);
  }

  private clearTracking() {
    if (this.polling != null) {
      clearTimeout(this.polling);
    }
    this.polling = null;
  }

  private get analysis(): Analysis {
    return this.$store.state.analyses.analysesContext;
  }

  private async beforeDestroy() {
    this.clearTracking();
    Promise.all([
      await analysesService.cleanup(),
      await cropsService.cleanup(),
      await monitoringService.cleanup()
    ]);
  }

}
